<template>
  <div class="page-box">
    <!-- 头部组件 -->
    <ProductHeader :currentTab="2.1" stepTitle="房型/价格计划"></ProductHeader>
    <div class="page-main">
      <!-- 发布助手 -->
      <PublishHelper></PublishHelper>
      <div class="main-content">
        <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">新增房型</span>
            </a-col>
          </a-row>
          <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules"
                        :label-col="currentFormLayout.labelCol" :wrapper-col="currentFormLayout.wrapperCol"
          >
            <a-form-model-item label="房型名称" prop="optionName">
              <a-input v-model="ruleForm.optionName" :maxLength="20" style="max-width:700px;" placeholder="请输入">
                <span slot="addonAfter">{{ ruleForm.optionName.length }}/20</span>
              </a-input>
            </a-form-model-item>
            <a-form-model-item label="房型图片" style="margin-bottom:0;">
              <div>建议图片长宽比为1:1，图片大小在800px*800px以上</div>
              <a-upload
                name="avatar"
                listType="picture-card"
                :fileList="fileList"
                :action="uploadFileUrl"
                :before-upload="handleBeforeUploadImage"
                @preview="handlePreview"
                @change="handleChange"
                :remove="handleRemove"
              >
                <div>
                  <a-icon type="plus"/>
                  <div class="ant-upload-text">上传</div>
                </div>
                <a-modal width="500px" :visible="previewVisible" :footer="null" @cancel="handleImgCancel">
                  <img alt="example" style="width: 100%" :src="previewImage"/>
                </a-modal>
              </a-upload>
            </a-form-model-item>
            <a-form-model-item label="床型">
              <a-select
                v-model="hotelBindBeds"
                mode="multiple"
                placeholder="请选择"
                option-label-prop="label"
                style="max-width:700px;"
                @change="handleTypeChange"
              >
                <a-select-option v-for="item in bedTypeList" :key="item.value" :value="item.value" :label="item.key">
                  <span role="img" :aria-label="item.key">{{ item.key }}</span>
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="楼层">
              <a-input v-model="ruleForm.optionFloor" style="max-width:700px;" :maxLength="10"
                       placeholder="请输入"></a-input>
            </a-form-model-item>
            <a-form-model-item label="窗户">
              <a-radio-group v-model="ruleForm.optionWindow" @change="onRadioChange">
                <a-radio :value="0">无</a-radio>
                <a-radio :value="1">有窗</a-radio>
                <a-radio :value="2">部分有窗</a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
              <a-button type="primary" :disabled="proSource!=0" @click="onSubmit" :loading="submitLoading">提交
              </a-button>
              <!-- <a-button  @click="backEvent" style="margin-left: 10px">保存草稿</a-button> -->
            </a-form-model-item>
          </a-form-model>
        </a-card>

      </div>
    </div>
  </div>
</template>

<script>
import ProductHeader from '../components/ProductHeader'
import PublishHelper from '../components/PublishHelper'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'

export default {
  name: 'HotelOptionInfo',
  components: {
    ProductHeader,
    PublishHelper
  },
  mixins: [ruleFormMixins],
  data() {
    return {
      proSource: this.$route.query.proSource, //判断自有产品还是非自有产品
      proId: this.$route.query.proId, //产品ID
      catalogId: this.$route.query.catalogId,
      optionId: this.$route.query.optionId,
      uploadFileUrl: this.getUploadFileUrl(),
      previewImage: '',
      ruleForm: {
        optionId: this.$route.query.optionId,
        optionBedType: '', //床型
        optionBedTypeArea: '', //床型面积
        optionCabinSize: '', //客房面积
        optionFloor: '', //分布楼层 ,
        optionHaveBreakfasts: 0, //早餐：0不含，1单早，2双早 ,
        optionIsExtraBed: 1, //是否加床
        optionIsWifi: 1, //Wifi：0无，1免费，2收费 ,
        optionName: '', //票型名称
        optionOtherDes: '', //其他说明
        optionProId: this.$route.query.proId,
        optionUseway: '', //入住须知
        optionBreakfast: '', //早餐详情
        optionImgs: '', //图片
        optionWindow: 0
      },
      bedTypeList: [],
      hotelBindBeds: [],
      submitLoading: false,
      previewVisible: false,
      submitFormData: '',
      rules: {
        optionName: [
          { required: true, message: '请输入房型名称', trigger: 'blur' }
        ]
      },
      fileList: [],
      imageList: []
    }
  },
  mounted() {
    this.getOptioInfo()
    this.getBedTypeList()
  },
  methods: {
    //获取图片上传地址
    getUploadFileUrl() {
      let appConfig = this.getAppConfig()
      return appConfig.baseUrl + (appConfig.isDev ? '/' : '') + 'base/upload'
    },
    handleImgCancel() {
      this.previewVisible = false
    },
    // 图片上传
    handleChange({ fileList }) {
      this.getLogUtils().logWithTag('handleChange', fileList)
      // 2. read from response and show file link
      let list = fileList.map(file => {
        if (file.response) {
          // Component will show file.url as link
          file.url = file.response.data
        }
        return file
      })
      this.fileList = list
      this.getLogUtils().logWithTag('handleChange====fileList', this.fileList)
    },
    handleRemove(file) {
      this.getLogUtils().logWithTag('handleRemove', file)
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
      this.getLogUtils().logWithTag('handleRemove==this.fileList', this.fileList)
    },
    async handlePreview(file) {
      this.getLogUtils().logWithTag('handlePreview', file)
      this.previewImage = file.url
      this.previewVisible = true
    },
    handleBeforeUploadImage(file) {
      this.getLogUtils().logWithTag('handleBeforeUploadImage', file)
      // 限制图片 格式、size、分辨率
      const isJPG = file.type === 'image/jpeg'
      const isJPEG = file.type === 'image/jpeg'
      const isGIF = file.type === 'image/gif'
      const isPNG = file.type === 'image/png'
      if (!(isJPG || isJPEG || isGIF || isPNG)) {
        this.$message.error('上传图片的格式不正确，不是JPG、JPEG、GIF、PNG')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 3
      if (!isLt2M) {
        this.$message.error('上传的文件不能大于3M!')
        return false
      }
      return true
    },
    handleTypeChange(value) {
      this.getLogUtils().logWithTag('handleTypeChange', value)
      if (value && value.length > 0) {
        this.ruleForm.optionBedType = value.join(',')
      } else {
        this.ruleForm.optionBedType = ''
      }
      this.getLogUtils().logWithTag('handleTypeChange', this.ruleForm.optionBedType)
    },
    onRadioChange(e) {
      this.getLogUtils().logWithTag(`checked = ${e.target.value}`)
      this.ruleForm.optionWindow = e.target.value
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    getImageStr(list) {
      if (list && list.length > 0) {
        let arr = list.map(item => {
          return item.url
        })
        return arr.join(',')
      } else {
        return ''
      }
    },
    // 保存接口
    submitData() {
      this.submitLoading = true
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.submitFormData.optionImgs = this.getImageStr(this.fileList)
      delete this.submitFormData.inTime
      this.getLogUtils().logWithTag('submitData', this.submitFormData)
      this.getHttpServices().getProService().post('product/hotel/editHotelOption', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('酒店房型信息保存成功')
        this.ruleForm.optionId = res
        this.$router.push({
          name: 'HotelOptionList',
          query: {
            proId: this.proId,
            catalogId: this.catalogId,
            proSource: this.proSource
          }
        })
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    //获取酒店房型
    getBedTypeList() {
      this.getHttpServices().getProService().get('product/hotel/getBedTypeList').then(res => {
        this.getLogUtils().logWithTag('getBedTypeList', res)
        this.bedTypeList = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 获取酒店房型信息
    getOptioInfo() {
      if (this.optionId != 0) {
        this.getHttpServices().getProService().get('product/hotel/getHotelOption?optionId=' + this.optionId).then(res => {
          this.getLogUtils().logWithTag('getOptioInfo', res)
          this.ruleForm = res
          if (res.optionBedType) {
            this.hotelBindBeds = res.optionBedType.split(',')
            this.hotelBindBeds = this.hotelBindBeds.map(value => {
              return parseInt(value)
            })
          }
          if (res.optionImgs && res.optionImgs != '') {
            let arr = res.optionImgs.split(',')
            let imageList = []
            arr.forEach((item, index) => {
              let json = { url: item, uid: '-uid' + index, status: 'done', name: item }
              imageList.push(json)
            })
            this.fileList = imageList
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      }
    }
  }

}
</script>
<style lang="less" scoped>
.page-box {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  .page-main {
    margin: 10px;
    display: flex;
    width: calc(100% - 20px);
    flex-grow: 1;

    .main-content {
      margin-left: 10px;
      width: 400px;
      flex-grow: 1;
    }
  }
}

.pt10 {
  padding-top: 10px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
